export const commaDelimiter = { label: ', (comma)', value: ',' };
export default [
  commaDelimiter,
  { label: '; (semicolon)', value: ';' },
  { label: 'Tab', value: '\t' },
  { label: '| (pipe)', value: '|' },
  { label: 'Space', value: ' ' },
];
